






































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AppMediumsModule } from '@/store/Settings/AppMediumsModule';
import AppMediumState from '@/components/Settings/AppMediums/AppMediumState.vue';
import AppMediumEdit from '@/components/Settings/AppMediums/AppMediumEdit.vue';
import AppMediumType from "@/models/Settings/AppMediums/AppMediumType";
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AppMediumDetails', components: { AppMediumState, AppMediumEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    AppMediumType = AppMediumType;

    get appMedium() {
        return AppMediumsModule.appMedium;
    }

}
